import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import HeaderFooter from "../components/headerFooter";
require("dayjs/locale/th");
dayjs.locale("th");

const columns = [
  { id: "sender", label: "ผู้ส่ง", align: "center", width: "300px" },
  {
    id: "dateTimeStart",
    label: "วัน - เวลา ที่เริ่ม",
    align: "center",
    width: "280px",
  },
  { id: "place", label: "ต้นทาง - ปลายทาง", align: "center", width: "300px" },
  { id: "typeFlight", label: "ประเภท", align: "center", width: "200px" },
  {
    id: "weight",
    label: "น้ำหนัก",
    align: "center",
    width: "200px",
  },
];

const DeliveryCar = (props) => {
  const [listBookingNotSuccess, setListBookingNotSuccess] = useState([]);
  const [listBookingIsSuccess, setListBookingIsSuccess] = useState([]);

  useEffect(() => {
    const formatDate = (date) => dayjs(date).format("D MMM YYYY");
    const formatTime = (time) => dayjs(time).format("HH.mm") + " น.";

    let listBooking = props.booking;

    if (listBooking != null) {
      const currentDate = new Date().toISOString();
      const listA = [];
      const listB = [];

      listBooking.map((booking) => {
        const formattedBooking = {
          bookingId: booking.idDeliveryCarBooking,
          nameLabel: "ผู้ส่ง ",
          name: booking.name,
          email: booking.email,
          phone: booking.telephoneMobile,
          startDateLabel: "วันที่เริ่ม ",
          startDate: formatDate(booking.date),
          startTime: `${formatTime(booking.startTime)}-${formatTime(
            booking.endTime
          )}`,
          fromPlace: booking.fromPlace,
          toPlace: booking.toPlace,
          typeProduct: `วัสดุ ${booking.typeProduct}`,
          weightProduct: `${booking.weightProduct} KG`,
        };

        if (booking.date < currentDate) {
          listA.push(formattedBooking);
        } else {
          listB.push(formattedBooking);
        }
      });

      setListBookingIsSuccess(listA);
      setListBookingNotSuccess(listB);
    }
  }, []);

  return (
    listBookingIsSuccess &&
    listBookingNotSuccess && (
      <HeaderFooter
        columns={columns}
        listBookingIsSuccess={listBookingIsSuccess}
        listBookingNotSuccess={listBookingNotSuccess}
        showHistory={props.showHistory}
        typeOfBooking={props.typeOfBooking}
        onClickCardHandler={props.onClickCardHandler}
      />
    )
  );
};

export default DeliveryCar;
